module.exports = __webpack_public_path__ + "static/media/tag_interactive_parcours.0f06f43b.svg";